
import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
@Component({})
export default class OficinaTuristica extends Vue {
  private win = window;
  private base = window.location;
  private left = false;
  private listTours: Array<any> = [];

  private mounted() {
    this.tours();
  }

  private tours() {
    axios
      .get("tours/list")
      .then((res: any) => {
        this.listTours = res.data;
      })
      .catch((err: any) => {
        console.log(err);
      });
  }

  private routerGo(name: string) {
    if (name && name != "") {
      if (this.$router.currentRoute.name == name) {
        this.$router.go(0);
      } else {
        this.$router.push({ name: name }).catch(err => {
          console.log(err);
        });
      }
    }
  }

  private toursGo(nombreWeb: any) {
    if (
      this.$router.currentRoute.name == "DetalleTours" &&
      this.$router.currentRoute.params.nombre == nombreWeb
    ) {
      this.$router.go(0);
    } else {
      this.$router
        .push({
          name: "DetalleTours",
          params: { nombre: nombreWeb }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
}
